"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Deal
exports.DEALS = 'deals';
exports.DEAL = 'deal';
// Orders
exports.ORDERS = 'orders';
// User
exports.CUSTOMERS = 'customers';
// Translations
exports.DIGITAL = 'digital';
// Shared
exports.CURRENT = 'current';
exports.PRINT = 'print';
exports.TOTAL = 'total';
exports.TRANSLATIONS = 'translations';
exports.SAVE = 'save';
// basket
exports.ON_BASKET = 'on-basket';
// my details
exports.UPDATE_MY_DETAILS = 'update-my-details';
// redirected to payment
exports.REDIRECTED_TO_PAYMENT = 'redirected-to-payment';
exports.FINANCE_CALCULATOR = 'finance-calculator';
exports.FINANCE_PACKAGES = 'finance-packages';
exports.FINANCE_PRODUCTS = 'finance-products';
exports.FINANCE_QUOTE = 'finance-quote';
exports.CALCULATE_FOR_DISPLAY = 'calculate-for-display';
//# sourceMappingURL=apiPaths.js.map